import { render, staticRenderFns } from "./ClientListPage.vue?vue&type=template&id=5d023da3&scoped=true"
import script from "./ClientListPage.vue?vue&type=script&lang=js"
export * from "./ClientListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d023da3",
  null
  
)

export default component.exports